/**
 * useScreenFlow Hook
 * Hook for accessing the ScreenFlowContext
 */

import { useContext } from 'react';
import { ScreenFlowContext } from '../contexts/ScreenFlowContext';
import type { ScreenFlowContextType } from '../types/contexts';

export function useScreenFlow(): ScreenFlowContextType {
  const context = useContext(ScreenFlowContext);
  if (!context) {
    throw new Error('useScreenFlow must be used within a ScreenFlowProvider');
  }
  return context;
}